module.exports = __webpack_public_path__ + "img/Dont_Stretch_warp_compress.bc703d56.png";